import styled, { css } from 'styled-components';

type ZillowNavbarSubSectionsListProps = {
    isVertical: boolean;
};

export const ZillowNavbarSubSectionsList = styled.ul<ZillowNavbarSubSectionsListProps>`
    list-style: none;
    margin-inline: 0px;
    padding-inline: 0px;
    margin-block: 0px;
    display: flex;
    ${({ isVertical }) => css`
        flex-direction: ${isVertical ? 'column' : 'row'};
    `}
`;
